import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { z } from 'zod';
import emailjs from '@emailjs/browser';

// EmailJS configuration
export const SERVICE_ID = 'service_xpabmrf';
export const TEMPLATE_ID = 'template_26fecur';
export const PUBLIC_KEY = 'c-y8351ibVVmQ4Cdk';

// Form schema definition
export const formSchema = z.object({
  name: z.string().min(2, {
    message: 'Imiona muszą mieć co najmniej 2 znaki.',
  }),
  email: z.string().email({
    message: 'Proszę podać poprawny adres email.',
  }),
  wedding_date: z.date({
    required_error: "Proszę wybrać datę ślubu.",
  }),
  wedding_location: z.string().min(2, {
    message: 'Miejsce ślubu musi mieć co najmniej 2 znaki.',
  }),
  message: z.string().min(10, {
    message: 'Wiadomość musi mieć co najmniej 10 znaków.',
  }),
  gdpr_consent: z.boolean().refine((val) => val === true, {
    message: "Musisz zaakceptować warunki RODO aby kontynuować",
  }),
  ceremony_type: z.string().optional(),
  service_type: z.string().optional(),
});

// Available ceremony types
export const ceremonyTypes = [
  { value: 'cywilny', label: 'Ślub Cywilny' },
  { value: 'koscielny', label: 'Ślub Kościelny' },
  { value: 'plenerowy', label: 'Ślub Plenerowy' },
  { value: 'humanistyczny', label: 'Ślub Humanistyczny' }
];

// Available service types
export const serviceTypes = [
  { value: 'fotografia', label: 'Fotografia' },
  { value: 'film', label: 'Film' },
  { value: 'fotografia + film', label: 'Fotografia + Film' }
];

// Helper function to send email via EmailJS
export const sendContactEmail = async (data: z.infer<typeof formSchema>) => {
  const formattedDate = format(data.wedding_date, 'dd.MM.yyyy', { locale: pl });
  
  const templateParams = {
    from_name: data.name,
    from_email: data.email,
    wedding_date: formattedDate,
    wedding_location: data.wedding_location,
    ceremony_type: data.ceremony_type || 'Nie wybrano',
    service_type: data.service_type || 'Nie wybrano',
    message: data.message,
    to_name: 'Czułe Klisze',
  };
  
  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    templateParams,
    {
      publicKey: PUBLIC_KEY,
    }
  );
};

// Helper for mailto fallback
export const prepareMailtoFallback = (data: Partial<z.infer<typeof formSchema>>) => {
  const subject = `Wiadomość od ${data.name || ''}`;
  let body = `
Imię i nazwisko: ${data.name || ''}
Email: ${data.email || ''}
`;

  if (data.wedding_date) {
    body += `Data ślubu: ${format(data.wedding_date, 'dd.MM.yyyy', { locale: pl })}\n`;
  }

  if (data.wedding_location) {
    body += `Miejsce ślubu: ${data.wedding_location}\n`;
  }

  body += `\nWiadomość:\n${data.message || ''}`;
  
  return {
    subject: encodeURIComponent(subject),
    body: encodeURIComponent(body)
  };
};

// Get a list of years for the date selector
export const getYearsList = (yearsAhead = 5) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: yearsAhead + 1 }, (_, i) => currentYear + i);
};
